import { useCallback, useEffect, useState } from 'react';
import { ordersListener, pastOrderListener } from '~/firebase/listeners/order';

import { User } from 'firebase/auth';
import { CollectionSnapShotFn } from '~/firebase/listeners/type';
import { PlatformOrder, PlatformOrderWithId } from '~/types/order';

export default function useOrders(
  auth: User | null,
  platformId: string | undefined,
  enterpriseGroupBuyId?: string,
) {
  const [orders, setOrders] = useState<Array<PlatformOrderWithId>>([]);
  const [pastOrders, setPastOrders] = useState<Array<PlatformOrderWithId>>([]);

  const handleOrdersSnapshot = useCallback<CollectionSnapShotFn>(
    (snap) => {
      const orders = snap.docs
        .filter((i) => !i.data?.()?.['enterpriseGroupBuyId'] === !enterpriseGroupBuyId)
        .map((doc) => {
          return {
            id: doc.id,
            ...(doc.data() as PlatformOrder),
          };
        });

      setOrders(orders);
    },
    [setOrders, enterpriseGroupBuyId],
  );

  const handlePastOrderSnapshot = useCallback<CollectionSnapShotFn>(
    (snap) => {
      const pastOrders = snap.docs
        .filter((i) => !i.data?.()?.['enterpriseGroupBuyId'] === !enterpriseGroupBuyId)
        .map((doc) => {
          return {
            id: doc.id,
            ...(doc.data() as PlatformOrder),
          };
        });

      setPastOrders(pastOrders);
    },
    [setPastOrders, enterpriseGroupBuyId],
  );

  useEffect(() => {
    if (auth && platformId) {
      const ordersUnlisten = ordersListener(
        auth,
        platformId,
        handleOrdersSnapshot,
        enterpriseGroupBuyId,
      );

      const pastOrdersUnlisten = pastOrderListener(
        auth,
        platformId,
        handlePastOrderSnapshot,
        enterpriseGroupBuyId,
      );

      return () => {
        ordersUnlisten();
        pastOrdersUnlisten();
      };
    }
  }, [auth, platformId, enterpriseGroupBuyId]);

  return { orders, pastOrders };
}
